// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PatientUpsearchModelSecureUpsearchModel {
    static getAttributeTypeMap() {
        return PatientUpsearchModelSecureUpsearchModel.attributeTypeMap;
    }
}
PatientUpsearchModelSecureUpsearchModel.discriminator = undefined;
PatientUpsearchModelSecureUpsearchModel.additionalProperties = false;
PatientUpsearchModelSecureUpsearchModel.attributeTypeMap = [
    {
        "name": "canUpdate",
        "baseName": "canUpdate",
        "type": "boolean"
    },
    {
        "name": "canInsert",
        "baseName": "canInsert",
        "type": "boolean"
    },
    {
        "name": "skipSearch",
        "baseName": "skipSearch",
        "type": "boolean"
    },
    {
        "name": "model",
        "baseName": "model",
        "type": "PatientUpsearchModel"
    },
];
//# sourceMappingURL=patientUpsearchModelSecureUpsearchModel.js.map